/**
 * Fonctions pour mettre à jour le cache après modifications locales
 * Permet de modifier les données en cache sans recharger depuis l'API
 */

import { cacheGet, cacheSet, emitCacheUpdated } from './cache';
import { mergeAttendance } from './attendanceMerge';

/**
 * Met à jour une ligne d'attendance dans le cache
 * @param {number} rowId - ID de la ligne
 * @param {Object} updates - Champs mis à jour
 */
export function updateAttendanceInCache(rowId, updates) {
  const attendance = cacheGet('activity/attendance', []);
  
  const updatedAttendance = attendance.map(row => {
    if (row.id === rowId) {
      return { ...row, ...updates };
    }
    return row;
  });
  
  cacheSet('activity/attendance', updatedAttendance);
  emitCacheUpdated('activity/attendance');
  
  console.log(`✅ [cacheUpdate] Row ${rowId} mise à jour dans le cache`);
}

/**
 * Ajoute une nouvelle ligne d'attendance dans le cache
 * Utilise mergeAttendance pour déduplication et tri
 * @param {Object} newRow - Nouvelle ligne à ajouter
 */
export function addAttendanceToCache(newRow) {
  const attendance = cacheGet('activity/attendance', []);
  
  // Merge avec dédup + tri
  const merged = mergeAttendance(attendance, [newRow]);
  
  cacheSet('activity/attendance', merged);
  emitCacheUpdated('activity/attendance');
  
  console.log(`✅ [cacheUpdate] Nouvelle ligne ${newRow.id} ajoutée au cache`);
}

/**
 * Supprime une ligne d'attendance du cache
 * @param {number} rowId - ID de la ligne à supprimer
 */
export function removeAttendanceFromCache(rowId) {
  const attendance = cacheGet('activity/attendance', []);
  
  const updatedAttendance = attendance.filter(row => row.id !== rowId);
  
  cacheSet('activity/attendance', updatedAttendance);
  emitCacheUpdated('activity/attendance');
  
  console.log(`✅ [cacheUpdate] Row ${rowId} supprimée du cache`);
}
